<template>
  <div class="wrapper">
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="sendSingle"
      title="SEND"
    >
      <i class="material-icons-outlined align-middle">send</i>
    </a>
    <a href="javascript:void(0);" @click="viewAs">
      <i class="material-icons-outlined align-middle">visibility</i>
    </a>
  </div>
</template>

<script>
import { getOnlyDocDataQuery } from "@/vendor/database";

export default {
  methods: {
    sendSingle: function () {
      this.params.context.componentParent.sendSingle(this.params.data);
    },
    viewAs: async function () {
      const result = await getOnlyDocDataQuery(
        "consultants",
        "email",
        this.params.data.email
      );
      if (result.ok) {
        const consultant = result.data;
        this.$store.commit("setTechSlackId", consultant.data.slack_id);
        this.$store.commit("setTechUserId", consultant.id);
        this.$store.commit("setTechUserName", consultant.data.name);
        this.$store.commit("setViewingAs", {
          role: "consultant",
          email: consultant.data.email,
          name: consultant.data.name,
          slackId: consultant.data.slack_id,
          id: consultant.id,
          photoURL: consultant.data.photo_url,
          path: this.$router.currentRoute.path,
        });
        this.$router.push({
          path: "/home/consultant/consultant_dashboard",
          query: { id: consultant.id },
        });
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: 68px;
  display: flex;
  align-items: center;
}
</style>
